export const DB_NAME = "MULTIPLACER-PROD";
export const CLUSTER_NAME = "mcbim";

export const HOTKEYS = {
  SNAP_TO_GRID: "alt+s",
  TRUE_SIZE: "alt+d",
  DELETE_PRODUCT: "backspace",
  COPY_PRODUCT_TO_CLIPBOARD: "ctrl+c",
  PASTE_PRODUCT: "ctrl+v",
  ROTATE_PRODUCT: "ctrl+r",
  ABORT: "esc",
  MEASURE: "ctrl+w",
};

export const LOCAL_STORAGE_KEYS = {
  FILE_FLOOR_JOB: "fileFloorJob",
};

// frontend/src/constants/disciplines.ts

export type DisciplineCode = "A" | "B" | "E" | "I" | "V" | "Z";

export const DISCIPLINES: Record<
  DisciplineCode,
  {
    code: DisciplineCode;
    label: string;
    shortLabel: string;
    color: string; // hex
  }
> = {
  A: { code: "A", label: "ARK", shortLabel: "ARK", color: "#9E9E9E" }, // grå
  B: { code: "B", label: "RIB", shortLabel: "RIB", color: "#1F1F1F" }, // svart-ish
  E: { code: "E", label: "RIE", shortLabel: "RIE", color: "#E91E63" }, // rosa
  V: { code: "V", label: "RIV", shortLabel: "RIV", color: "#1E88E5" }, // blå
  I: { code: "I", label: "I", shortLabel: "I", color: "#8D6E63" }, // brunt
  Z: { code: "Z", label: "Z", shortLabel: "Z", color: "#7E57C2" }, // whatever (lila)
};

export const DISCIPLINE_ORDER: DisciplineCode[] = ["A", "B", "E", "I", "V", "Z"];

// Optional helpers
export const getDisciplineLabel = (code?: string | null): string =>
  code && (code as DisciplineCode) in DISCIPLINES
    ? DISCIPLINES[code as DisciplineCode].label
    : (code ?? "");

export const getDisciplineColor = (code?: string | null): string =>
  code && (code as DisciplineCode) in DISCIPLINES
    ? DISCIPLINES[code as DisciplineCode].color
    : "#BDBDBD";
